<template>
  <div class="container-view">
    <Breadcrumbs />
    <div class="col-12">
      <Listado :arrayEntidades="this.arrayEntidades" />
    </div>
    <q-page-sticky position="bottom-right" :offset="[28, 28]">
      <q-btn
        data-cy="new-entidad"
        fab
        icon="add"
        title="Crear nueva entidad"
        color="primary"
        @click="_createEntidad()"
        :disabled="isDisabledNewBtn"
      />
    </q-page-sticky>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Listado from '../components/Listado.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import { QPageSticky } from 'quasar';

export default {
  computed: {
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin'
    })
  },
  components: { Listado, Breadcrumbs, QPageSticky },
  mixins: [Loading],
  data: function () {
    return {
      arrayEntidades: [],
      isDisabledNewBtn: false
    };
  },
  mounted () {
    this._callData();
    this.checkPermissions();
  },
  methods: {
    _callData () {
      let request = {};
      let idUser = this.$store.getters['PF/userId'];
      this.showLoading();
      request = {
        controller: this.isSuperAdmin ? `/Entidad` : `/Entidad/User/${idUser}`
      };

      this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.arrayEntidades = response.data;
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err.message);
        });
    },
    _createEntidad () {
      this.$router.push({ name: 'form_new_entidad' });
    },
    checkPermissions () {
      const isSuperAdmin = this.$store.getters['PF/isSuperAdmin'];
      const isAdminEntidad = this.$store.getters['PF/isAdminEntidad'];

      if (isSuperAdmin) { this.isDisabledNewBtn = false; return; }
      if (isAdminEntidad) { this.isDisabledNewBtn = true; }
    }
  }
};
</script>
